import React from 'react'

import ImageCropPreview from './image-crop-preview/ImageCropPreview'

const PostCover = ({ handleRemove, cover, croppedPostLink }) => (
  <div className='post-image'>
    {croppedPostLink ? (
      <img src={croppedPostLink} className='community-content__image' alt='community' />
    ) : (
      <ImageCropPreview {...cover} />
    )}
    {(cover?.imageUrl || croppedPostLink) && (
      <div className='post-image__remove-button'>
        <i className='fas fa-times' onClick={handleRemove} />
      </div>
    )}
  </div>
)
export default PostCover
